import { Dialog } from '@mui/material';
import queryString from 'query-string';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as TabilifeLogo } from '../../../../../assets/icon/tabi-life-black.svg';
import { BillStatus, OrderItemStatus } from '../../../../../consts';
import { useMenuContext } from '../../../../../context/MenuContext';
import { useOrderContext } from '../../../../../context/OrderContext';
import { useSystemContext } from '../../../../../context/SystemContext/SystemContext';
import { Order } from '../../../../../interfaces/types';
import { isRestaurantOnline } from '../../../../../utils';
import OrderItem from './OrderItem';

const OrderList: React.FC<{ orders: Order[] }> = ({ orders }) => {
  const { listRestaurantData } = useMenuContext();
  const { updateOrderDetails } = useOrderContext();
  const { seatInfo } = useSystemContext();

  const location = useLocation();
  const queryParams = queryString.parse(location.search);
  const navigate = useNavigate();

  const [dialogOpen, setDialogOpen] = React.useState(false);

  const { t } = useTranslation();

  const onShowDetail = (item: Order) => {
    const orderDetailLink = queryString.stringifyUrl({
      url: `/orderdetail/${item.id}`,
      query: queryParams,
    });
    navigate(orderDetailLink);
  };

  const onReorder = (item: Order) => {
    const restaurant = listRestaurantData.find((restaurant) => restaurant.id === item.restaurant_id);
    if (!seatInfo?.id) {
      return;
    }

    if (restaurant && !isRestaurantOnline(restaurant)) {
      setDialogOpen(true);
      return;
    }

    updateOrderDetails({
      bill_status: BillStatus.NOT_CLEARED,
      foods: item.foods.map((food) => {
        const { item_deleted_quantity, restaurant_name, restaurant_profile_pic, ...rest } = food;
        return rest;
      }),
      promotion_foods: item.promotion_foods.map((food) => {
        const { item_deleted_quantity, restaurant_name, restaurant_profile_pic, ...rest } = food;
        return rest;
      }),
      order_status: OrderItemStatus.PREPARING,
      order_table_number: seatInfo.id,
      seat_type: seatInfo.seat_type,
      seat_number: seatInfo.seat_number,
      payment_method: '',
      restaurant_id: item.restaurant_id,
    });

    const deliveryDetailLink = queryString.stringifyUrl({
      url: `/delivery`,
      query: queryParams,
    });
    navigate(deliveryDetailLink);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <div className="flex flex-col gap-3 flex-1 overflow-auto shadow-search no-scrollbar bg-[#F9FAFB]">
      {orders.map((order) => {
        const restaurant = listRestaurantData.find((restaurant) => restaurant.id === order.restaurant_id);
        return <OrderItem key={order.id} order={order} onShowDetail={onShowDetail} onReorder={onReorder} restaurant={restaurant} />;
      })}
      <div className="w-full flex gap-1 items-center justify-center mb-3">
        <p className="text-gray-700 text-sm font-medium leading-5 notranslate" translate="no">
          {t('POWERED_BY')}
        </p>
        <TabilifeLogo width={100} height={20} />
      </div>
      <Dialog open={dialogOpen} onClose={handleCloseDialog} sx={{ '& .MuiPaper-root': { borderRadius: '12px' } }}>
        <div className="p-6 flex flex-col gap-6">
          <div className="flex flex-col gap-1">
            <p className="text-black-900 text-lg font-semibold leading-7">{t('LISTRESTAURANT_MODAL_TITLE')}</p>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default OrderList;
